import React from "react";
import "../Termcomp/Termhero.css";
import bar from "../../assets/images/herobar.svg";

function TermHeroHero() {
  return (
    <div className="hero-content-term-container">
      <div className="term-header-sec">
      <h2>Terms and conditions</h2>
      </div>
    </div>
  );
}

export default TermHeroHero;
